/*
  Grupos de color en el filtro de colecciones (28-sep-2026, pedido de Roberto).
  El filtro "Color" es la categoria de Shopify (filter.v.t.shopify.color-pattern).
  Varios tonos se muestran como UN solo color: marcarlo marca todos sus tonos.
  - El valor "lider" (el del nombre del grupo, o el primero que aparezca) queda visible
    con el nombre del grupo; los demas tonos se ocultan.
  - Las pastillas de filtros activos se juntan en una sola, y quitarla quita todo el grupo.
  Solo toca el DOM que pinta facets.js; se reaplica cuando facets.js lo re-pinta.
  Para agregar grupos: editar GRUPOS (nombres tal como aparecen en el filtro).
  28-sep-2026 (tarde): Coral y Verde Oliva salen de Rosado y Verde y quedan como color propio
  (pedido de Roberto). Electric Coral se agrupa bajo Coral.
*/
(function () {
  if (window.__colorGrupos) return;
  window.__colorGrupos = true;

  var PARAM = 'filter.v.t.shopify.color-pattern';
  var GRUPOS = {
    'Rosado': ['Rosado', 'Fucsia', 'Perfectly Pink', 'Pink Punch', 'Power Pink', 'Taffy Pink', 'Rosa', 'Rosa Malva', 'Nube Rosa', 'Rose', 'Rose Petal', 'Peony Pink', 'Pretty In Pink', 'Pink Melon', 'Dusty Red', 'Sweet Berry', 'Sugar Melon', 'Tropical Hibiscus'],
    'Coral': ['Coral', 'Electric Coral'],
    'Morado': ['Morado', 'Lavanda', 'Lila', 'Passion Lilac', 'Wisteria', 'Púrpura'],
    'Turquesa': ['Turquesa', 'Cloud Blue', 'Fresh Mint', 'Poolside Blue', 'Sea Glass', 'Arctic Aqua'],
    'Verde': ['Verde', 'Gelato', 'Green Energy', 'Pistacho', 'Verde Menta', 'Verde Salvia', 'Sage', 'Cucumber'],
    'Negro': ['Negro', 'Negro (FLWS)'],
    'Celeste': ['Celeste', 'Azul Pálido'],
    'Rojo': ['Rojo', 'Desert Rouge'],
    'Azul Rey': ['Azul Rey', 'Electric Blue', 'Heritage Blue'],
    'Damasco': ['Damasco', 'Naranja'],
    'Khaki': ['Khaki', 'Beige'],
  // 28-sep-2026: los nombres de estampado (dibujos) se muestran como un solo "Estampado".
    'Estampado': ['Estampado', 'A cuadros', 'A rayas', 'Animal Print', 'Animales', 'Arcoíris', 'Brillos', 'Corazones', 'Floral', 'Frutas', 'Geométrico', 'Halloween', 'Lunares', 'Mariposa', 'Muelitas', 'Multicolor', 'Navidad', 'Princesas', 'Villanos']
  };
  // Solo en colecciones de estampados (handle con "estampad"): estos colores base tambien van a "Estampado".
  // Fuera de esas colecciones siguen como su propio color.
  var EXTRA_ESTAMPADOS = ['Damasco', 'Naranja', 'Electric Blue', 'Light Chambray'];
  if (/\/collections\/[^\/]*estampad/i.test(location.pathname)) {
    GRUPOS['Estampado'] = GRUPOS['Estampado'].concat(EXTRA_ESTAMPADOS);
  }

  // Pelotitas del filtro con otro color (solo en el filtro; no toca fichas ni tarjetas).
  var PELOTAS = {
    'verde': '#2e9e4f',
    'morado': '#7d3fbf',
    'azul rey': '#1640ef', // mismo tono que la pelota de Electric Blue
    'estampado': 'conic-gradient(#e2296f 0 60deg, #f6d94a 0 120deg, #2e9e4f 0 180deg, #106b98 0 240deg, #7d3fbf 0 300deg, #f08a3c 0 360deg)',
    'camuflaje': 'radial-gradient(circle at 22% 28%, #3b4a24 0 20%, transparent 21%), radial-gradient(circle at 72% 22%, #8a7a4a 0 18%, transparent 19%), radial-gradient(circle at 62% 68%, #2b3320 0 22%, transparent 23%), radial-gradient(circle at 24% 76%, #a0915e 0 16%, transparent 17%), radial-gradient(circle at 88% 58%, #4b5a2c 0 14%, transparent 15%), #6b7440'
  };

  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim();
  }
  var miembroDe = {};
  Object.keys(GRUPOS).forEach(function (g) {
    GRUPOS[g].forEach(function (m) { miembroDe[norm(m)] = g; });
  });

  function etiqueta(li) {
    var el = li.querySelector('.facet-checkbox__text-label');
    return el ? el.textContent : '';
  }

  // valores (gid) de cada grupo, leidos del filtro pintado
  var valoresGrupo = {};

  function aplicarLista(ul) {
    var lis = Array.prototype.slice.call(ul.querySelectorAll(':scope > li'));
    lis.forEach(function (li) {
      var bg = PELOTAS[norm(etiqueta(li))];
      var sw = bg && li.querySelector('.swatch');
      if (sw && sw.style.getPropertyValue('--swatch--background') !== bg) sw.style.setProperty('--swatch--background', bg);
    });
    var porGrupo = {};
    lis.forEach(function (li) {
      var inp = li.querySelector('input[name="' + PARAM + '"]');
      if (!inp) return;
      var g = miembroDe[norm(etiqueta(li))];
      if (!g) return;
      (porGrupo[g] = porGrupo[g] || []).push({ li: li, inp: inp, nombre: norm(etiqueta(li)) });
    });
    Object.keys(porGrupo).forEach(function (g) {
      var ms = porGrupo[g];
      var lider = ms.filter(function (m) { return m.nombre === norm(g); })[0] || ms[0];
      valoresGrupo[g] = valoresGrupo[g] || {};
      var algunoMarcado = false, algunoActivo = false, total = 0;
      ms.forEach(function (m) {
        valoresGrupo[g][m.inp.value] = true;
        if (m.inp.checked) algunoMarcado = true;
        if (!m.inp.disabled) algunoActivo = true;
        var c = m.li.querySelector('.facets__selected-count');
        // conteo original en data-n: sin esto cada pasada del observer re-sumaba el total ya escrito en el lider
        if (c && !c.hasAttribute('data-n')) c.setAttribute('data-n', (c.textContent || '').replace(/\D/g, ''));
        var n = c ? parseInt(c.getAttribute('data-n'), 10) : 0;
        if (!isNaN(n)) total += n;
        if (m !== lider) {
          m.li.style.display = 'none';
          m.li.setAttribute('data-color-grupo-oculto', g);
        }
        m.inp.setAttribute('data-color-grupo', g);
      });
      lider.li.style.display = '';
      lider.li.classList.remove('hidden');
      lider.inp.setAttribute('data-color-grupo-lider', g);
      lider.inp.checked = algunoMarcado;
      if (algunoActivo) {
        lider.inp.disabled = false;
        lider.inp.removeAttribute('disabled');
        var lab = lider.li.querySelector('.facet-checkbox, .facets__label');
        if (lab) lab.classList.remove('disabled');
      }
      var t = lider.li.querySelector('.facet-checkbox__text-label');
      if (t && t.textContent !== g) t.textContent = g;
      var c2 = lider.li.querySelector('.facets__selected-count');
      if (c2 && c2.textContent !== '(' + total + ')') c2.textContent = '(' + total + ')';
    });
    ordenar(ul);
    // Contador del encabezado ("Color (8)"): cada grupo marcado cuenta como 1.
    var det = ul.closest('details');
    var sum = det && det.querySelector('summary');
    if (sum) {
      var marcados = {};
      Array.prototype.forEach.call(ul.querySelectorAll('input[name="' + PARAM + '"]:checked'), function (inp) {
        marcados[inp.getAttribute('data-color-grupo') || inp.value] = true;
      });
      var n = Object.keys(marcados).length;
      Array.prototype.forEach.call(sum.querySelectorAll('*'), function (el) {
        if (el.children.length) return;
        var t = (el.textContent || '').trim();
        if (/^\(\d+\)$/.test(t) && t !== '(' + n + ')') el.textContent = '(' + n + ')';
      });
    }
  }

  // Orden del filtro (pedido de Roberto 28-sep): estos primero, el resto en el orden que venga.
  var ORDEN = ['Negro', 'Azul Marino', 'Caribbean Blue', 'Rojo', 'Gris', 'Azul Rey', 'Rosado', 'Teal Blue', 'Blanco', 'Burdeo', 'Celeste', 'Morado', 'Verde', 'Verde Oliva', 'Coral'].map(norm);

  function ordenar(ul) {
    var lis = Array.prototype.slice.call(ul.querySelectorAll(':scope > li'));
    if (!lis.length) return;
    var oculto = function (li) { return li.hasAttribute('data-color-grupo-oculto'); };
    var rango = function (li) { var k = ORDEN.indexOf(norm(etiqueta(li))); return k < 0 ? ORDEN.length : k; };
    var vis = lis.filter(function (li) { return !oculto(li); });
    var ord = vis.map(function (li, i) { return { li: li, r: rango(li), i: i }; })
      .sort(function (a, b) { return a.r - b.r || a.i - b.i; })
      .map(function (x) { return x.li; })
      .concat(lis.filter(oculto));
    var cambia = ord.some(function (li, i) { return li !== lis[i]; });
    if (cambia) ord.forEach(function (li) { ul.appendChild(li); });
    // "Mostrar mas" de Dawn (solo desktop): los primeros N visibles siempre a la vista.
    // N = cuantos venian sin show-more-item la primera vez (se guarda en el ul).
    if (!ul.querySelector(':scope > li.show-more-item') && !ul.hasAttribute('data-limite')) return;
    if (!ul.hasAttribute('data-limite')) {
      ul.setAttribute('data-limite', String(lis.filter(function (li) { return !li.classList.contains('show-more-item'); }).length));
    }
    var limite = parseInt(ul.getAttribute('data-limite'), 10);
    var abierto = !ul.querySelector(':scope > li.show-more-item.hidden');
    ord.forEach(function (li, i) {
      var arriba = !oculto(li) && i < limite;
      if (arriba) {
        if (li.classList.contains('show-more-item')) li.classList.remove('show-more-item');
        if (li.classList.contains('hidden')) li.classList.remove('hidden');
      } else {
        if (!li.classList.contains('show-more-item')) li.classList.add('show-more-item');
        if (!abierto && !li.classList.contains('hidden')) li.classList.add('hidden');
      }
    });
  }

  function aplicarPastillas() {
    var pills = Array.prototype.slice.call(document.querySelectorAll('facet-remove a.active-facets__button'));
    var porCont = new Map();
    pills.forEach(function (a) {
      var fr = a.closest('facet-remove');
      var cont = fr && fr.parentElement;
      if (!cont) return;
      if (!porCont.has(cont)) porCont.set(cont, []);
      porCont.get(cont).push(a);
    });
    porCont.forEach(function (as) {
      Object.keys(GRUPOS).forEach(function (g) {
        var vals = valoresGrupo[g] || {};
        var del = as.filter(function (a) {
          var span = a.querySelector('.active-facets__button-inner') || a;
          var t = norm(span.firstChild && span.firstChild.nodeType === 3 ? span.firstChild.nodeValue : a.textContent);
          t = t.replace(/^[^:]*:\s*/, '');
          return miembroDe[t] === g;
        });
        if (!del.length) return;
        var url = new URL(del[0].getAttribute('href'), location.origin);
        var quedan = url.searchParams.getAll(PARAM).filter(function (v) { return !vals[v]; });
        url.searchParams.delete(PARAM);
        quedan.forEach(function (v) { url.searchParams.append(PARAM, v); });
        del.forEach(function (a, k) {
          var fr = a.closest('facet-remove');
          if (k === 0) {
            var nuevoHref = url.pathname + url.search;
            if (a.getAttribute('href') !== nuevoHref) a.setAttribute('href', nuevoHref);
            var span = a.querySelector('.active-facets__button-inner') || a;
            var tn = span.firstChild;
            if (tn && tn.nodeType === 3) {
              var txt = tn.nodeValue.replace(/:\s*[^:]*$/, ': ' + g + ' ');
              if (tn.nodeValue !== txt) tn.nodeValue = txt;
            }
            if (fr.style.display) fr.style.display = '';
          } else if (fr.style.display !== 'none') {
            fr.style.display = 'none';
          }
        });
      });
    });
  }

  function aplicar() {
    var uls = document.querySelectorAll('ul');
    Array.prototype.forEach.call(uls, function (ul) {
      if (ul.querySelector(':scope > li input[name="' + PARAM + '"]')) aplicarLista(ul);
    });
    aplicarPastillas();
  }

  // Marcar/desmarcar el lider arrastra a todo el grupo. En captura: corre antes que facets.js lea el formulario.
  document.addEventListener('input', function (e) {
    var inp = e.target;
    if (!inp || !inp.getAttribute) return;
    var g = inp.getAttribute('data-color-grupo-lider');
    if (!g) return;
    var form = inp.form || inp.closest('form');
    if (!form) return;
    Array.prototype.forEach.call(form.querySelectorAll('input[data-color-grupo="' + g + '"]'), function (m) {
      if (m !== inp) m.checked = inp.checked;
    });
  }, true);

  var pendiente = false;
  function programar() {
    if (pendiente) return;
    pendiente = true;
    setTimeout(function () { pendiente = false; aplicar(); }, 120);
  }
  document.addEventListener('DOMContentLoaded', aplicar);
  if (document.readyState !== 'loading') aplicar();
  // facets.js reemplaza el HTML de los filtros; reaplicar cuando cambia (solo si hay filtros en la pagina).
  var raiz = document.querySelector('facet-filters-form') ? document.body : null;
  if (raiz && window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { programar(); return; }
      }
    }).observe(raiz, { childList: true, subtree: true });
  }
})();
